import React from 'react';

const Footer = () => {
  return (
    <footer className="text-center py-8 border-t border-gray-200 mt-12">
      <div className="flex flex-col items-center gap-3">
        <p className="text-gray-600 text-sm">
          Powered by <a href="https://www.litspark.solutions/?utm_source=allsmalltools" target="_blank" rel="noopener noreferrer" className="font-semibold text-indigo-600 hover:text-indigo-800 transition-colors">LitSpark</a>
        </p>
        <div className="flex gap-4 text-xs text-gray-500">
          <a href="/sitemap.xml" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition-colors">Sitemap</a>
          <span>•</span>
          <a href="/robots.txt" target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 transition-colors">Robots.txt</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;